import React, {memo} from 'react';
import BenutzerManagement from "../Components/BenutzerManagement/BenutzerManagement";
import Organisation from "../Components/OrganisationManagement/Organisation";

function OrganisationManagement() {
    return (

        <>
            <br/>

            <p className="handwai-text-label-main"> &nbsp; &nbsp;Organisation
                Management</p>
            <Organisation/>

            <br/>

            <p className="handwai-text-label-main">&nbsp; &nbsp;Benutzer
                Management</p>
            <BenutzerManagement/>
        </>
    )
}

export default memo(OrganisationManagement);